/**
 * @generated SignedSource<<b0b2e815458e5e26a1b06d9dd0898b7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentCheckoutMethods_checkout$data = {
  readonly value: number | null | undefined;
  readonly " $fragmentType": "PaymentCheckoutMethods_checkout";
};
export type PaymentCheckoutMethods_checkout$key = {
  readonly " $data"?: PaymentCheckoutMethods_checkout$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCheckoutMethods_checkout">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCheckoutMethods_checkout",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "type": "Checkout",
  "abstractKey": null
};

(node as any).hash = "4cf10b11d68bf14c27de3b12ad77301f";

export default node;
